import React, { useContext } from 'react'

import type { IParam } from 'libs/apis'
import type {
  ITicketSelectBranchesState,
  ITicketSelectBranchList,
  ITicketSelectBranchSinglePartial,
} from './model'

const branches: [] = []
const page = 1
const searchParams = {}
const updateTicketSelectBranches = (): void => void 0

export const initialState: ITicketSelectBranchesState = {
  branches,
  page,
  searchParams,
  updateTicketSelectBranches,
}

export const TicketSelectBranchContext = React.createContext(initialState)

export const useTicketSelectBranchContext = (): ITicketSelectBranchesState => {
  return useContext(TicketSelectBranchContext)
}

type Action = {
  type: 'UPDATE'
  payload: {
    newBranch: ITicketSelectBranchList[]
    page: number
    searchParams: IParam & ITicketSelectBranchSinglePartial
  }
}

export const reducer = (
  state: ITicketSelectBranchesState,
  action: Action,
): ITicketSelectBranchesState => {
  const { type, payload } = action

  switch (type) {
    case 'UPDATE':
      return {
        ...state,
        branches: payload.newBranch,
        page: payload.page,
        searchParams: payload.searchParams,
      }

    default:
      throw new Error(`Unknown company ${type} type`)
  }
}
